import { render, staticRenderFns } from "./UIMessage.vue?vue&type=template&id=20947b5a&scoped=true"
import script from "./UIMessage.vue?vue&type=script&lang=js"
export * from "./UIMessage.vue?vue&type=script&lang=js"
import style0 from "./UIMessage.vue?vue&type=style&index=0&id=20947b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20947b5a",
  null
  
)

export default component.exports